import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: '10px'
    },
    label: {
      margin: 0,
      fontWeight: 500,
      fontSize: '14px',
      lineHeight: '17px',
      fontStyle: 'normal'
    },
    input: {
      fontWeight: 600,
      backgroundColor: palette.background.underBox,
      color: `${palette.text.darker}`,
      padding: '10px',
      fontSize: '16px',
      border: 'none',
      height: '40px',
      lineHeight: '20px',
      borderRadius: palette.borderRadius.default,
      '&:focus': {
        outline: 'none'
      },
      '&::placeholder': {
        color: `${palette.text.primary}50`,
        fontStyle: 'italic'
      }
    },
    inputError: {
      margin: '0px 10px',
      fontWeight: 500,
      fontSize: '10px',
      lineHeight: '17px',
      fontStyle: 'normal',
      color: palette.danger.red
    }
  });
const useStyle = makeStyles(style);
export default useStyle;
